exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-exclamation-circle[data-v-47704d23]{color:#ffc72c;font-size:80px}p[data-v-47704d23]:last-child{margin-bottom:0}", ""]);

// exports
